'use strict';
import axios from 'axios';
import ENV from '../environtment'
import router from "./../../../router/index";

const baseUrl = ENV.api
const costumHeader = ENV.costumHeader

const actions = {
  getGlobalConfig(context, params = {}) {
    return new Promise(async (resolve) => {
      try {
        const url = `${baseUrl}/user/getglobalconfig`
        const result = await axios.get(url, {
          ...costumHeader('Get Global Config', 4),
          params,
        })
        if (result) if (result.data) if (result.data.code == 200) {
          context.commit("SET_BILLING_INFO", result.data.data.companyInfo)
          return resolve(result.data.data) 
        }
        context.dispatch('nShowMessage', {type: 'warning', msg: result.data.message})
        return resolve({})
      } catch (e) {
        context.dispatch('nShowMessage', {type: 'error', msg: e.message})
        return resolve({})
      }
    })
  },
  setDataLogin(context, data = {}) {
    if (data.company.is_active != true) {
      context.commit("SET_STATUS", "failed");
      context.commit("SET_ERROR", "Your company is not active");
    } else if (data.user.status === 1) {
      context.commit("SET_USERNAME", data.user.full_name);
      context.commit("SET_USEREMAIL", data.user.email);
      context.commit("SET_COMPANY", data.company.id);
      context.commit("SET_COMPANY_NAME", data.company.name_company);
      context.commit("SET_GROUP_ID", data.group.id);
      context.commit("SET_STATUS", "success");
      context.commit("SET_ERROR", null);
      context.commit("SET_CUTOFF_DATE", data.company.cutoff_date);
      context.commit("SET_ROLE", data.user.role);
      context.commit("SET_BILLING_INFO", data.companyInfo)

      let role = ''
      const checkRoute = router.currentRoute.name == 'login'
      switch (data.user.role) {
        case 0:
          role = 'Admin HRD'
          context.commit("SET_AUTHENTICATED", true);
          if (checkRoute) router.push({ name: "summary-report" })
          break
        case 2:
          role = 'Admin Appsensi'
          context.commit("SET_AUTHENTICATED", true);
          context.commit("SET_ADMINISTRATOR", true);
          if (checkRoute) router.push({ name: "summary-report" })
          break
        case 3:
          role = 'Supervisor'
          context.commit("SET_AUTHENTICATED", true);
          if (checkRoute) router.push({ name: "summary-report" })
          break
        case 4:
          role = 'Executive'
          context.commit("SET_AUTHENTICATED", true);
          if (checkRoute) router.push({ name: "summary-report" })
          break

        default:
          context.commit("SET_AUTHENTICATED", false);
          context.commit("SET_STATUS", "failed");
          context.commit("SET_ERROR", "You are not authorized to view this page");
          if (!checkRoute) router.push({ name: "login" })
          break
      }

      const profile = {
        groupId: data.group.id,
        group: data.group.alias,
        zone: data.group.zones,
        accessType: role,
        jobPosition: data.user.job_position,
        companyInfo: data.companyInfo
      }
      context.commit("SET_USER_DETAIL", profile);
      context.commit('SET_CCMPANY_DETAIL', data.company)
    } else if (data.user.status === 0) {
      context.commit("SET_STATUS", "failed");
      context.commit("SET_ERROR", "User is inactive, please activate to continue.");
  }
  }
}

export default { actions }
